import React from "react";
import {ThreeDots} from "react-loader-spinner";

const ImageLoader = () => {
  return (
    <>
      <ThreeDots
        visible={true}
        height="80"
        width="80"
        color="#342c6e"
        radius="9"
        ariaLabel="three-dots-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </>
  );
};

export default ImageLoader;
